import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import "./tableGrid.css";

const TableGrid = ({ columns, data, handleSort, sortValue, sortOrder }) => {

    return <React.Fragment>
        <table className="CaseSelectorTable">
            <thead>
                <tr className="CaseSelectorHeaders tblThead">
                    {
                        columns.map((column, key)=> {
                            const { width, textAlign, title, noSort, sortyBy, hidden } = column;
                            const ascendingClass = (sortValue === sortyBy && sortOrder === "asc") ? "active" : "";
                            const decendingClass = (sortValue === sortyBy && sortOrder === "desc") ? "active" : "";
                            return !hidden && <th style={{ width: `${width}px`, textAlign }} key={key}>
                                <div className="tblColTextBlock">
                                    <div className="tblColName">
                                        {title}
                                    </div>
                                    { !noSort &&
                                        <div className="tblColSortIcons">
                                            <div className={ascendingClass + " FaChevronUp"} onClick={() => !ascendingClass && handleSort(sortyBy, "asc")}>
                                                <FaChevronUp />
                                            </div>
                                            <div className={decendingClass+ " FaChevronDown"} onClick={() => !decendingClass && handleSort(sortyBy, "desc")}>
                                                <FaChevronDown />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </th>
                        })
                    }
                </tr>
            </thead>
            <tbody>
                {
                    data.map((row, id) => {
                        return <tr key={id}>
                            {
                                columns.map((column, index) => {
                                    const { name, format, textAlign, className='', onClick, getClassName, params } = column;
                                    const key = id+'_'+index;
                                    const value = format ? format((name ? row[name] : row), row) : row[name];
                                    return <td
                                                style={{textAlign}}
                                                key={key}
                                                className={className + (getClassName ? getClassName(row) : '')}
                                                onClick={() => onClick && onClick(params ? row[params] : row)}
                                            >
                                                {value}
                                            </td>
                                })
                            }
                        </tr>
                    })
                }
            </tbody>
        </table>
    </React.Fragment>
}

export default TableGrid;


// WEBPACK FOOTER //
// ./src/common/components/TableGrid/tableGrid.jsx